
<div class="row">
    <div class="col-12">
  
        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'ORGANIZATION.EDIT_ORGANIZTION' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm btn-back"  onClick="history.back()">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onUpdate()" >
                        <!-- [disabled]="!formValid" Временное скрытие валидации -->
                        <!-- <i class="bi bi-save"></i>  -->
                        {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div id="stepper1" class="bs-stepper">
                    
                    <div class="bs-stepper-header">
                        <div class="step" data-target="#test-l-1">
                            <button class="step-trigger">
                                <span class="bs-stepper-circle">1</span>
                                <span class="bs-stepper-label">{{ 'ORGANIZATION.BASIC_INFORMATION' | translate }}</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#test-l-2">
                            <button class="step-trigger">
                                <span class="bs-stepper-circle">2</span>
                                <span class="bs-stepper-label">{{ 'EMPLOEE.EMPLOEES' | translate }}</span>
                            </button>
                        </div>
                        <!-- <div class="line"></div>
                        <div class="step" data-target="#test-l-3">
                            <button class="step-trigger">
                                <span class="bs-stepper-circle">3</span>
                                <span class="bs-stepper-label">{{ 'ADDITIONAL_INFORMATION' | translate }}Дополнительные сведения</span>
                            </button>
                        </div> -->
                    </div>

                    <div class="bs-stepper-content">

                        <div id="test-l-1" class="content">
                            <!-- <app-organization-edit-basic (changeFormEvent)="setData($event)"></app-organization-edit-basic> -->
                            <app-organization-basic [inputDataForForm]="inputDataForForm" (changeFormEvent)="setData($event)"></app-organization-basic>
                            <div class="stepper-btn-box">
                                <button (click)="nextStep()" class="btn btn-primary btn-sm">{{ 'PROCEED' | translate }}</button>
                            </div>
                        </div>

                        <div id="test-l-2" class="content">
                            <app-organization-employees [data]="tableData"></app-organization-employees>
                            <div class="stepper-btn-box">
                                <button (click)="prevStep()" class="btn btn-light btn-sm prev-step">{{ 'BACK' | translate }}</button>
                                <!-- <button (click)="nextStep()" class="btn btn-primary btn-sm">Продолжить</button> -->
                            </div>
                        </div>

                        <!-- <div id="test-l-3" class="content">
                            <app-organization-addinfo></app-organization-addinfo>
                            <button (click)="prevStep()" class="btn btn-primary btn-sm prev-step">Вернуться</button>
                        </div> -->

                    </div>

                </div>

            </div>

        </div>

    </div>
</div>